import { useTranslation } from "react-i18next";

/**
 * The MSES wordmark: "MSES" in Unbounded (the only place that face is used)
 * and the tagline beside it — OVR's, renamed. `board` on the blue band,
 * `paper` on white.
 */
export function Wordmark({ tone = "board", compact = false }: { tone?: "board" | "paper"; compact?: boolean }) {
	const { t } = useTranslation();
	return (
		<span className="flex min-w-0 items-baseline gap-[0.5rem] whitespace-nowrap">
			<span
				className={`font-bold font-display leading-none tracking-[0.01em] ${compact ? "text-[1rem]" : "text-[1.375rem]"} ${
					tone === "board" ? "text-white" : "text-board"
				}`}
			>
				{t("app.wordmark")}
			</span>
			{!compact && (
				<span className={`truncate text-[0.75rem] ${tone === "board" ? "text-on-board" : "text-muted"}`}>{t("app.tagline")}</span>
			)}
		</span>
	);
}
